import { useState } from "react";
import { FormattedMessage } from "react-intl";
import image from "./campus.svg";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper";
import IntroImage from "../../introImage.component";
import { useHistory } from "react-router-dom";
import { pageNames } from "../../../../reduxStore/reducers/main";
import { setQueryParams } from "../../../../app/RouteWithSubRoutes";
import { useEffect } from "react";
import StandardHeadline from "../../../elements/text/standardHeadline.text";
import { nativeStorageInterface } from "../../../..";

export default function ChoosePiKey(props) {
  const [chosenKey, setChosenKey] = useState(null);
  const history = useHistory();

  const handleChange = (e) => {
    const value = e.target.value;
    console.log(value, chosenKey);
    setChosenKey(value);
  };
  const handleSubmit = () => {
    // TODO: choose piKey-> go on to the language page!
    props.setPiKeyState(chosenKey);
    nativeStorageInterface.set("piKey", chosenKey);
    const url = new URL(window.location);
    setQueryParams("piKey", chosenKey);
    history.push({
      pathname: `/${pageNames.intro}/${pageNames.selectLanguage}`,
      search: url.searchParams.toString(),
    });
  };
  useEffect(() => {
    setChosenKey(props.loginPiKeys[0].key);
  }, []);

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(handleSubmit, <FormattedMessage id="welcome.next" />, {
          className: "normalButton--primary",
        }),
      ]}
    >
      <IntroImage fallbackImage={image} imageName={"campus.svg"} />
      <div className="d-flex flex-column pl-3 pr-3 align-items-center">
        <StandardHeadline className="mb-3">
          <FormattedMessage id="intro.choosePiKey.title" />
        </StandardHeadline>
        <div className="d-flex flex-column align-items-start">
          {props.loginPiKeys.map((value, index) => (
            <label type="button" key={index} className="d-flex">
              <input
                onChange={handleChange}
                className="mr-2"
                type="radio"
                value={value.key}
                name="gender"
                checked={chosenKey === value.key}
              />
              <span>{value.name}</span>
            </label>
          ))}
        </div>
      </div>
    </BottomButtonContainer>
  );
}
